import ESTIMATE_CONSTANT from "../constant/estimateConstant"
import type EstimateValues from "../types/params"
import getNumberOfLayers from "./getNumberOfLayers"

export const isDesign = ({ serviceD }: Pick<EstimateValues, "serviceD">) => {
  return serviceD
}
export const isManufacture = ({ serviceM }: Pick<EstimateValues, "serviceM">) => {
  return serviceM
}
export const isMount = ({ serviceG }: Pick<EstimateValues, "serviceG">) => {
  return serviceG
}
export const isProcurement = ({ partsProcurementCourse }: Pick<EstimateValues, "partsProcurementCourse">) => {
  return partsProcurementCourse
}

export const isRigid = ({ kibanType }: Pick<EstimateValues, "kibanType">) => {
  return kibanType === ESTIMATE_CONSTANT.基板の種類.リジッド基板.value
}
export const isFlexible = ({ kibanType }: Pick<EstimateValues, "kibanType">) => {
  return kibanType === ESTIMATE_CONSTANT.基板の種類.フレキシブル基板.value
}
export const isMetal = ({ kibanType }: Pick<EstimateValues, "kibanType">) => {
  return kibanType === ESTIMATE_CONSTANT.基板の種類.メタル放熱基板.value
}
export const isAluminum = ({ metalBoard }: Pick<EstimateValues, "metalBoard">) => {
  return metalBoard === ESTIMATE_CONSTANT.メタル材質.アルミ.value
}
export const isCopper = ({ metalBoard }: Pick<EstimateValues, "metalBoard">) => {
  return metalBoard === ESTIMATE_CONSTANT.メタル材質.銅.value
}
export const isMetalCore = ({ layer }: Pick<EstimateValues, "layer">) => {
  switch (layer) {
    case ESTIMATE_CONSTANT.構成層数["2層アルミコア"].value:
    case ESTIMATE_CONSTANT.構成層数["2層銅コア"].value:
    case ESTIMATE_CONSTANT.構成層数["2層銅コアポスト"].value:
      return true
    default:
      return false
  }
}

export const isMultiLayer = (values: Pick<EstimateValues, "layer">) => {
  return getNumberOfLayers(values) >= 3
}

export const isBuildUp = ({ layer, buildUpMethod }: Pick<EstimateValues, "layer" | "buildUpMethod">) => {
  // 入力状態を変更する際に非表示の項目は状態が変わらないことにより以下のような不具合が起きるため、構成層数による判断も行っています。
  // ・ビルドアップでなし以外を選択した後に、構成層数を2層に戻すとビルドアップありと誤判定される
  // TODO 表示の状態に関わらず状態を変化させる仕組みを作ってこの処理を外すべきか？要検討
  if (!isMultiLayer({ layer })) {
    return false
  }

  switch (buildUpMethod) {
    case ESTIMATE_CONSTANT.ビルドアップ工法["1-2-1 BHなし"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["1-2-1 BHあり スタガード"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["1-2-1 BHあり スタック"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(4層)"].value:

    case ESTIMATE_CONSTANT.ビルドアップ工法["1-4-1 BHなし"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["1-4-1 BHあり"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["2-2-2 BHなし"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["2-2-2 スタック"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["2-2-2 BHあり スタガード"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["2-2-2 BHあり フルスタック"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(6層)"].value:

    case ESTIMATE_CONSTANT.ビルドアップ工法["1-6-1 BHなし"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["2-4-2 BHなし"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["2-4-2 BHなし スタック"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["2-4-2 BHあり スタガード"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["2-4-2 BHあり フルスタック"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["3-2-3 BHなし スタガード"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["3-2-3 BHなし スタック"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["3-2-3 BHあり フルスタック"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(8層)"].value:

    case ESTIMATE_CONSTANT.ビルドアップ工法["1-8-1"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["2-6-2"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["3-4-3"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(10層)"].value:

    case ESTIMATE_CONSTANT.ビルドアップ工法["1-10-1"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["2-8-2"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["3-6-3"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["4-4-4"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(12層)"].value:
      return true
    default:
      return false
  }
}

export const isRogers = ({ board }: Pick<EstimateValues, "board">) => {
  return board === ESTIMATE_CONSTANT.材質["Rogers材（4350B）"].value
}
export const isMEGTRON6 = ({ board }: Pick<EstimateValues, "board">) => {
  return board === ESTIMATE_CONSTANT.材質["パナソニック材（MEGTRON6）"].value
}
export const isCEM3 = ({ board }: Pick<EstimateValues, "board">) => {
  return board === ESTIMATE_CONSTANT.材質["CEM-3"].value
}
